<template>
  <b-container>
    <div v-if="hasPermission([consts.permissions.CREATE_CLASSES_RESOURCES]) && periodEnd"><div class="font-weight-bold mb-3">Periodos académicos finalizados</div></div>
    <div v-if="!hasPermission([consts.permissions.CREATE_CLASSES_RESOURCES]) && periodEnd">
      <div class="p-5 font-size-30">
        <div class="font-weight-bold mb-3">Periodos académicos finalizados</div>
        <div>Pronto habilitaremos nuevamente este módulo para que puedas revisar y descargar tus notas.</div>
        <!-- <div class="font-weight-bold font-size-70 mb-1">:D</div> -->
        <router-link to="/" class="btn btn-outline-primary width-100">Home</router-link>
      </div>
    </div>
    <b-row class="justify-content-md-center" v-if="!periodEnd">
      <div class="card" style="max-width: 70rem;">
        <div class="card-header card-header-flex" style="width: 100%; overflow-x: auto; overflow-y: hidden;">
          <div class="d-flex flex-column justify-content-center mr-auto">
            <h5 class="mb-0 mr-4" style="min-width: max-content;">{{ dataClass.subject.name}}</h5>
          </div>
          <a-tabs defaultActiveKey="1" class="kit-tabs-bold" @change="changeTab">
            <!-- <a-tab-pane tab="Tablero" key="1"  v-if="teacherEditableView"/> -->
            <a-tab-pane tab="Calificaciones" key="1" />
            <a-tab-pane v-if="hasPermission([consts.permissions.CREATE_CLASSES_RESOURCES])" tab="Indicadores" key="3" />
            <a-tab-pane v-if="hasPermission([consts.permissions.CREATE_CLASSES_RESOURCES])" tab="Yo puedos" key="2" />
          </a-tabs>
        </div>
        <div v-show="tabActive == 2">
          <div style="width: 70rem;"></div>
            <div class="card-body">
              <h4 class=""><b>Docente</b>: {{ dataClass.tenuredTeacher.fullName }} </h4>
              <h4 class=""><b>Periodo</b>: {{ dataClass.namePeriodo }} </h4>
              <h4 class="" v-if="dataClass.group.name"><b>Grupo</b>: {{ dataClass.group.name }} </h4>
              <a-divider />
              <div>
                <b-button v-b-modal.modal-search-create-descriptor v-if="teacherEditableView">Seleccionar Descriptor</b-button>
                <b-button v-if="!isElective && descriptors.length > 0" v-b-modal.modal-export-descriptorIcan class="ml-2" @click="getGroupExport()">Exportar Estructura</b-button>
              </div>
              <b-row>
                <b-col>
                  <h5 class="mt-2">Lista de descriptores</h5>
                  <b-table striped hover :fields="descriptorColumns" :items="descriptors" head-variant="light" responsive
                    class="mt-2" v-show="descriptors.length > 0">
                    <template #cell(id)="descriptor">
                      {{ descriptor.item.id }}
                    </template>
                    <template #cell(description)="descriptor">
                      {{ descriptor.item.description }}
                    </template>
                    <template #cell(iCan)="descriptor">
                      <div v-if="!hasPermission([consts.permissions.CREATE_CLASSES_RESOURCES])" class="d-inline-block" style="font-size: 1.5rem;">
                        <b-form-tag v-for="tag in descriptor.item.iCanList" no-remove :key="tag.iddescriptor"
                        :title="''+tag.id" class="mr-1">{{ tag.id }}</b-form-tag>
                      </div>
                      <div v-else class="d-inline-block" style="font-size: 1.5rem;">
                        <b-form-tag v-for="tag in descriptor.item.iCanList" no-remove :disabled="!teacherEditableView" @remove="removeICan(tag.id, tag.idDescriptorICan)"
                          :key="tag.iddescriptor" :title="''+tag.id" class="mr-1">{{ tag.id }}</b-form-tag>
                      </div>
                    </template>
                    <template #cell(actions)="descriptor">
                      <b-row no-gutters>
                        <b-col lg="8" class="pt-1">
                          <b-link @click="openSearchCreateICan(descriptor.item)">Seleccionar Yo puedo</b-link>
                        </b-col>
                        <b-col md="4" lg="4" xl="4">
                          <a-tooltip placement="top">
                            <template slot="title">
                              <span>Remover descriptor</span>
                            </template>
                            <button v-if="descriptor.item.iCanList.length < 1" type="button"
                              @click="removeDescriptor(descriptor.item.idDescriptorICan)" class="btn btn-light">
                              <i class="fa fa-trash text-red" />
                            </button>
                          </a-tooltip>
                        </b-col>
                      </b-row>
                    </template>
                  </b-table>
                  <empty-table v-show="descriptors.length === 0" />
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <h5 class="mt-2">Lista de los yo puedo</h5>
                  <b-table striped hover :fields="columnsICan" :items="iCanList" head-variant="light" responsive class="mt-2"
                    v-show="iCanList.length > 0">
                  </b-table>
                  <empty-table v-show="iCanList.length === 0" />
                </b-col>
              </b-row>
            </div>
        </div>
        <div v-if="tabActive == 3">
          <div style="width: 70rem;"></div>
          <div class="card-body">
            <b-row>
              <b-col sm="12" md="6">
                <h4 class=""><b>Docente</b>: {{ dataClass.tenuredTeacher.fullName }} </h4>
                <h4 class=""><b>Periodo</b>: {{ dataClass.namePeriodo}} </h4>
                <h4 v-if="!isElective" class=""><b>Grupo</b>: {{ dataClass.group.name }} </h4>
              </b-col>
              <b-col sm="12" md="6" v-if="hasPermission([consts.permissions.CREATE_CLASSES_RESOURCES])">
                  <p class="text-right">
                    {{ checkTimeLeft }}
                  </p>
                  <p class="text-muted text-right">
                    Última modificación: {{ lastUpdated }}
                  </p>
                  <p class="text-right">
                    <b-form-checkbox v-model="autoSave" name="check-button" switch :disabled="!teacherEditableView">Autoguardado</b-form-checkbox>
                  </p>
                  <p class="text-right">
                    <b-button variant="primary" :disabled="!isRecentChanges" v-show="!autoSave" @click="saveGrades()">
                      <i class="fe fe-save mr-1" aria-hidden="true"></i>Guardar
                    </b-button>
                  </p>
              </b-col>
            </b-row>
            <a-divider/>
            <b-row class="text-center mt-2" v-show="showSkeleton">
              <b-col md="6" offset-md="3">
                <div>
                  <a-skeleton active/>
                </div>
              </b-col>
            </b-row>
            <performanceIndicators @updatedAt="recieveUpdatedAt" :dataInfo="dataQualificationsToSend" :isElective="isElective ? true : false" :currentPeriod="currentPeriod" :idClass="this.dataClass.id" :teacherEditableView="this.teacherEditableView"/>
          </div>
        </div>
        <div v-show="tabActive == 1">
          <div style="width: 70rem;"></div>
          <div class="card-body">
            <b-row>
              <b-col sm="12" md="6">
                <h4 class=""><b>Docente</b>: {{ dataClass.tenuredTeacher.fullName }} </h4>
                <h4 class=""><b>Periodo</b>: {{ dataClass.namePeriodo}} </h4>
                <h4 v-if="!isElective" class=""><b>Grupo</b>: {{ dataClass.group.name }} </h4>
              </b-col>
              <b-col sm="12" md="6" v-if="hasPermission([consts.permissions.CREATE_CLASSES_RESOURCES])">
                  <p class="text-right">
                    {{ checkTimeLeft }}
                  </p>
                  <p class="text-muted text-right">
                    Última modificación: {{ lastUpdated }}
                  </p>
                  <p class="text-right">
                    <b-form-checkbox v-model="autoSave" name="check-button" switch :disabled="!teacherEditableView">Autoguardado</b-form-checkbox>
                  </p>
                  <p class="text-right">
                    <b-button variant="primary" :disabled="!isRecentChanges" v-show="!autoSave" @click="saveGrades()">
                      <i class="fe fe-save mr-1" aria-hidden="true"></i>Guardar
                    </b-button>
                  </p>
              </b-col>
            </b-row>
            <a-divider/>
            <b-row v-if="hasPermission([consts.permissions.CREATE_CLASSES_RESOURCES]) && !qualificationData.state">
              <b-col>
                <h5><b-alert variant="warning" show class="m-auto" >
                  <b-row>
                    <b-col sm="10" class="m-auto">
                      {{ qualificationData.text }}
                    </b-col>
                    <b-col sm="1" class="m-auto">
                      <b-button @click="openModalStudents()" variant="outline-warning">Detalles</b-button>
                    </b-col>
                  </b-row>
                </b-alert></h5>
              </b-col>
            </b-row>
              <div>
                <b-form-group class="offset-sm-1" label-cols-sm="3" label="Listar por:">
                  <b-form-radio-group
                    v-model="listBy"
                    :options="showBy"
                    class="pt-2 pb-1 ml-1"
                    value-field="item"
                    text-field="name"
                  ></b-form-radio-group>
                </b-form-group>
                <b-form-group class="offset-sm-1" label-cols-sm="3" :label="textOption">
                  <b-form-select v-if="listBy === 'iCan'"
                    v-model="optionSelected"
                    :options="iCanOptions"
                    class="col-md-6"
                    required
                  ></b-form-select>
                  <b-form-select v-else
                    v-model="optionSelected"
                    :options="students"
                    class="col-md-6"
                    required
                  ></b-form-select>
                </b-form-group>
              </div>
            <b-row class="text-center mt-2" v-show="showSkeleton">
              <b-col md="6" offset-md="3">
                <div>
                  <a-skeleton active/>
                </div>
              </b-col>
            </b-row>
            <b-row class="text-center" v-show="iCanOptions.length > 0 && showTable && listBy === 'iCan'">
              <b-col>
                <div>
                  <div id="spreadsheet" ref="spreadsheet" ></div>
                  <empty-table v-show="iCanOptions.length === 0" />
                </div>
              </b-col>
            </b-row>
            <b-row class="text-center" v-show="students.length > 0 && showTable && listBy === 'student'">
              <b-col>
                <div style="overflow-x: scroll;">
                  <div id="spreadsheetStudent" ref="spreadsheetStudent"></div>
                  <empty-table v-show="students.length === 0" />
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </b-row>
    <b-modal id="modal-missing-grades" title="Yo puedos sin calificar" ok-only ok-variant="secondary" ok-title="Cerrar"
      size="lg">
      <b-table striped hover :fields="columns" :fixed="true" :items="qualificationData.students" head-variant="light" responsive :bordered="true">
        <template #cell(user)="student">
          {{ student.item[0] }}
        </template>
        <template #cell(iCans)="student">
          {{ student.item[1].join(', ') }}
        </template>
      </b-table>
    </b-modal>
    <b-modal id="modal-search-create-iCan" title="Seleccionar Yo puedo" ok-only ok-variant="secondary" ok-title="Cerrar"
      size="xl">
      <i-can :idDescriptorSelectedToEdit="descriptorSelectedToEdit.id" />
    </b-modal>
    <b-modal id="modal-search-create-descriptor" title="Seleccionar Descriptor" ok-only ok-variant="secondary"
      ok-title="Cerrar" size="xl">
      <descriptor />
    </b-modal>
    <b-modal id="modal-export-descriptorIcan" title="Seleccionar grupo" hide-footer size="md">
      <b-row>
        <b-col v-if="isGroupName">
          <b-form-group
            label="Seleccione el grupo en el que desea exportar la estructura"
            v-slot="{ ariaDescribedby }"
            class="justify-content-md-center"
          >
            <b-form-checkbox
              v-for="group in groupName[0]"
              v-model="selected"
              :key="group.id"
              :value="group.subject[0].id"
              :aria-describedby="ariaDescribedby"
              name="flavour-4a"
              inline
            >
              {{ group.name }}
            </b-form-checkbox>
          </b-form-group>
            <b-button @click="exportDescriptorsIcans()" class="mr-2 mb-3 mt-3" variant="primary">Exportar</b-button>
            <b-button @click="clearSelected()" variant="secondary" size="sm" class="ml-1 ">
            Cancelar
            </b-button>
        </b-col>
        <b-col v-else>No se encontró grupo del mismo grado para realizar exportación</b-col>
      </b-row>
    </b-modal>
  </b-container>
</template>

<script>
import iCan from '@/components/custom/ican'
import descriptor from '@/components/custom/descriptor'
import emptyTable from '@/components/custom/cardEmptyList'
import { consts, hasPermission, hasRole, showErrorMessage } from '@/services/utilities'
import apiClient from '@/services/axios'
import apiClient2 from '@/services/axios/v2'
import { mapState } from 'vuex'
import axios from 'axios'
import jexcelStyle from 'jexcel/dist/jexcel.css' // eslint-disable-line no-unused-vars
import jexcel from 'jexcel'
import { ToastFire } from '@/services/utilities/swal'
import Swal from 'sweetalert2'
import moment from 'moment'
import performanceIndicators from '@/components/custom/performanceIndicators'
import store from 'store'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 8000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  components: {
    iCan,
    descriptor,
    emptyTable,
    performanceIndicators,
  },
  name: 'newClassRoomSBG',
  data() {
    var self = this
    return {
      selected: [],
      groupName: [],
      isGroupName: false,
      childSelected: '',
      columns: [
        { key: 'user', label: 'Nombre y Apellido' },
        { key: 'iCans', label: 'Códigos' },
      ],
      qualificationData: {
        students: [],
        text: '',
        state: true,
      },
      jExcelObj: {},
      gradesExcel: {},
      teacherEditableView: false,
      dataClass: {
        subject: {
          name: '',
        },
        group: {
          name: '',
        },
        tenuredTeacher: {
          fullName: '',
        },
      },
      idClass: '',
      tabActive: 1,
      autoSave: true,
      currentPeriod: '',
      dataQualificationsToSend: '',
      isRecentChanges: false,
      lastUpdated: '',
      typingTimer: '',
      periodFinalDate: '',
      checkTimeLeft: '',
      periodEnd: true,
      timer: null,
      intervalTimer: 1000,
      descriptorColumns: [
        { key: 'id', label: 'Código' },
        { key: 'description', label: 'Descriptor', thStyle: { width: '50%' } },
        { key: 'iCan', label: 'Lista de yo puedo' },
        { key: 'actions', label: 'Acciones', thClass: 'text-center', tdClass: 'align-middle' },
      ],
      descriptors: [
      ],
      descriptorSelectedToEdit: {},
      columnsICan: [
        { key: 'id', label: 'Código' },
        { key: 'description', label: 'Yo puedo' },
        { key: 'dimension', label: 'Dimensión' },
      ],
      iCanList: [],
      iCanListByStudent: {},
      nICan: 0,
      isElective: false,
      showBy: [
        { item: 'student', name: 'Estudiante' },
        { item: 'iCan', name: 'Yo puedo' },
      ],
      listBy: 'student',
      showTable: false,
      showSkeleton: false,
      showSkeletonDiv: false,
      optionSelected: null,
      iCanOptions: [],
      students: [],
      studentList: [],
      textOption: '',
      firstTime: 0,
      options: {
        updateTable: function (instance, cell, col, row, val, label, cellName) {
          if (row % 2 === 1) {
            cell.style.backgroundColor = '#f3f3f3'
          }
          if (col === 0 || col === 1) {
            cell.style.color = '#000000'
          }
        },
        minDimensions: [3, 1],
        allowInsertRow: false,
        allowInsertColumn: false,
        onchange: self.changed,
        onload: self.loaded,
        onbeforechange: self.beforeChange,
        onafterchanges: self.afterchanges,
        allowDeleteRow: false,
        allowDeleteColumn: false,
        rowDrag: false,
        columnDrag: false,
        columnSorting: false,
        contextMenu: function (obj, x, y, e) {
          const items = []
          if (obj.options.allowExport) {
            items.push({
              title: obj.options.text.saveAs,
              shortcut: 'Ctrl + S',
              onclick: function () {
                obj.download()
              },
            })
          }
          if (obj.options.allowRenameColumn) {
            items.push({
              title: obj.options.text.renameThisColumn,
              onclick: function() {
                obj.setHeader(x)
              },
            })
          }
          return items
        },
      },
      options2: {
        updateTable: function (instance, cell, col, row, val, label, cellName) {
          if (row % 2 === 1) {
            cell.style.backgroundColor = '#f3f3f3'
          }
          if (col === 0 || col === 1) {
            cell.style.color = '#000000'
          }
        },
        minDimensions: [3, 1],
        allowInsertRow: false,
        allowRenameColumn: false,
        allowInsertColumn: false,
        onchange: self.changed,
        onload: self.loaded,
        onbeforechange: self.beforeChange,
        onafterchanges: self.afterchanges,
        onchangeheader: self.changeheader,
        allowDeleteRow: false,
        allowDeleteColumn: false,
        rowDrag: false,
        columnDrag: false,
        columnSorting: false,
        contextMenu: function (obj, x, y, e) {
          const items = []
          if (obj.options.allowExport) {
            items.push({
              title: obj.options.text.saveAs,
              shortcut: 'Ctrl + S',
              onclick: function () {
                obj.download()
              },
            })
          }
          return items
        },
      },
      consts: consts,
      dataExport: {},
      idRoles: [],
    }
  },
  beforeRouteEnter(to, from, next) {
    const isElective = to.query.elective
    const childSelected = to.params.childSelected
    let elective = isElective ? '?elective=true' : '?elective=false'
    if (childSelected !== null) {
      elective = elective + '&childSelected=' + to.params.childSelected
    }

    function getDataClass() {
      if (!isElective) {
        return apiClient.get('/group-subjects/' + to.params.idClass)
      } else {
        return apiClient2.get('/electives/' + to.params.idClass)
      }
    }

    function getQualifications() {
      return apiClient.get(`/qualifications/sbg/classes/${to.params.idClass + elective}`)
    }

    function getMissingQualifications() {
      return apiClient.get('/qualifications/sbg/classes/' + to.params.idClass + '/missing-qualifications' + elective)
    }

    function getICanList() {
      return apiClient.get(`/descriptors/icans/${to.params.idClass + elective}`)
    }

    axios.all([getDataClass(), getICanList(), getQualifications(), getMissingQualifications()])
      .then(axios.spread(function (dataClass, dataICanList, dataQualifications, dataMissing) {
        next((vm) => {
          vm.setDataClass(null, dataClass, isElective, childSelected)
          vm.setDataICanList(null, dataICanList.data)
          vm.setDataQualifications(null, dataQualifications.data)
          vm.setDataPeriodsQualifications(null, dataQualifications.data)
          vm.setDataMissingQualifications(null, dataMissing.data, to.params.idClass)
        })
      }))
      .catch(err => {
        next((vm) => {
          vm.setDataClass(err, [])
          vm.setDataICanList(err, [])
          vm.setDataQualifications(err, [])
          vm.setDataPeriodsQualifications(err, [])
          vm.setDataMissingQualifications(err, [], null)
        })
      })
  },
  computed: {
    ...mapState(['user']),
  },
  watch: {
    options: {
      handler: function (after, before) {
        console.log(after)
      },
      deep: true,
    },
    options2: {
      handler: function (after, before) {
        console.log(after)
      },
      deep: true,
    },
    listBy: function () {
      this.optionSelected = null
    },
    optionSelected: function (value) {
      if (value === null) {
        this.showTable = false
      } else {
        this.showTable = false
        this.showSkeleton = true
        this.searchBy()
        setTimeout(() => {
          this.showTable = true
          this.showSkeleton = false
        }, 1000)
      }
    },
  },
  methods: {
    hasPermission(permissions) {
      return hasPermission(permissions, this.user.permissions)
    },
    timeLeft() {
      if (this.periodFinalDate !== null) {
        const now = moment()
        const finalDate = moment(this.periodFinalDate)
        if (finalDate.diff(now, 'days') < 21) {
          this.checkTimeLeft = 'Quedan ' + finalDate.diff(now, 'days') + ' días y ' + moment.duration(finalDate.diff(now)).hours() + ' horas para cerrar el periodo'
        } else if (finalDate.diff(now, 'seconds') < 1) {
          this.checkTimeLeft = 'Periodo finalizado'
        }
        this.periodEnd = finalDate.diff(now, 'seconds') < 1
      }
    },
    setDataClass(err, dataClass, isElective, childSelected) {
      if (err) {
        this.error = err.toString()
      } else {
        this.childSelected = childSelected
        this.isElective = isElective
        this.dataClass = (isElective) ? dataClass.data.data : dataClass.data
        if ((this.dataClass.idAssistantTeacher === this.$store.state.user.id || this.dataClass.idTenuredTeacher === this.$store.state.user.id || hasRole(this.idRoles, consts.roles.ADMIN_ACADEMICO) || hasRole(this.idRoles, consts.roles.COORDINADOR)) && hasPermission([consts.permissions.UPDATE_CLASSES_RESOURCES], this.$store.state.user.permissions)) {
          this.teacherEditableView = true
        } else {
          this.teacherEditableView = false
          this.descriptorColumns = this.descriptorColumns.filter(col => col.key !== 'actions')
        }
      }
    },
    setDataICanList(err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        this.iCanList = data.iCanList
        this.iCanOptions = []
        for (const ican of this.iCanList) {
          this.iCanOptions.push({
            value: ican.id,
            text: ican.id + ' - ' + ican.description,
          })
        }
        this.iCanOptions.unshift({ value: null, text: 'Seleccione un Yo puedo' })
        this.iCanOptions = [...this.iCanOptions]
        this.descriptors = data.descriptorList
        this.dataExport.idSubject = data.idSubject !== undefined ? data.idSubject : this.dataExport.idSubject
        this.dataExport.idGrade = data.idGrade !== undefined ? data.idGrade : this.dataExport.idGrade
        this.dataExport.idTenuredTeacher = data.idTenuredTeacher !== undefined ? data.idTenuredTeacher : this.dataExport.idTenuredTeacher
        this.dataExport.idGroup = data.idGroup !== undefined ? data.idGroup : this.dataExport.idGroup
      }
    },
    setDataQualifications(err, dataQualifications) {
      if (err) {
        this.error = err.toString()
      } else {
        this.currentPeriod = dataQualifications.period.id
        this.students = []
        for (const student of dataQualifications.options.data) {
          this.students.push({
            value: student[0],
            text: student[1],
          })
        }
        this.dataQualificationsToSend = {
          performanceList: dataQualifications.performanceList,
          options: dataQualifications.performanceTable.options,
          period: dataQualifications.period,
          observationList: dataQualifications.observationList,
        }
        this.students.unshift({ value: null, text: 'Seleccione un estudiante' })
        const studentList = []
        if (this.optionSelected !== null && this.listBy === 'iCan') {
          for (const student of dataQualifications.options.data) {
            if (student.length > 2 && student[2].length > 0) {
              let checkDone = false
              for (let k = 0; k < student[2].length; k++) {
                if (this.optionSelected === student[2][k][0] && !checkDone) {
                  if (student[2][k][1] === '') {
                    student[2][k][1] = 0
                  }
                  studentList.push([student[0], student[1], student[2][k][1]])
                  checkDone = true
                } else if (k === student[2].length - 1 && !checkDone) {
                  studentList.push([student[0], student[1], 0])
                }
              }
            } else {
              studentList.push([student[0], student[1], 0])
            }
          }
        }
        this.options.data = studentList
        this.options.includeHeadersOnDownload = dataQualifications.options.includeHeadersOnDownload
        this.periodFinalDate = dataQualifications.period.finalDate
        this.options.operator = dataQualifications.options.operator
        this.options.automatic = dataQualifications.options.automatic
        this.options.nestedHeaders = dataQualifications.options.nestedHeaders
        this.options.columns = dataQualifications.options.columns
        if (this.listBy === 'student') {
          this.options.columns[1].title = 'Description'
        } else {
          this.options.columns[1].title = 'Name'
        }
        this.lastUpdated = dataQualifications.lastUpdated
        if (this.firstTime < 1) {
          const jExcelObj = jexcel(this.$refs.spreadsheet, this.options)
          this.jExcelObj = Object.assign({}, jExcelObj)
        } else {
          document.getElementById('spreadsheet').innerHTML = ''
          const jExcelObj = jexcel(this.$refs.spreadsheet, this.options)
          this.jExcelObj = Object.assign({}, jExcelObj)
        }
      }
    },
    setDataPeriodsQualifications(err, dataPeriodsQualifications) {
      if (err) {
        this.error = err.toString()
      } else {
        const iCanList = []
        if (this.optionSelected !== null && this.listBy === 'student') {
          for (let i = 0; i < dataPeriodsQualifications.options.data.length; i++) {
            const iCanListed = []
            if (this.optionSelected === dataPeriodsQualifications.options.data[i][0]) {
              for (const iCan of this.iCanList) {
                if (dataPeriodsQualifications.options.data[i].length > 2 && dataPeriodsQualifications.options.data[i][2].length > 0) {
                  let checkDone = false
                  for (let k = 0; k < dataPeriodsQualifications.options.data[i][2].length; k++) {
                    if (iCan.id === dataPeriodsQualifications.options.data[i][2][k][0] && !checkDone) {
                      if (!iCanListed.includes(iCan.id)) {
                        if (dataPeriodsQualifications.options.data[i][2][k][1] === '') {
                          dataPeriodsQualifications.options.data[i][2][k][1] = 0
                        }
                        iCanList.push([iCan.id, iCan.description, dataPeriodsQualifications.options.data[i][2][k][1]])
                        iCanListed.push(iCan.id)
                      }
                      checkDone = true
                    } else if (k === dataPeriodsQualifications.options.data[i][2].length - 1 && !checkDone) {
                      if (!iCanListed.includes(iCan.id)) {
                        iCanList.push([iCan.id, iCan.description, 0])
                        iCanListed.push(iCan.id)
                      }
                    }
                  }
                } else {
                  if (!iCanListed.includes(iCan.id)) {
                    iCanList.push([iCan.id, iCan.description, 0])
                    iCanListed.push(iCan.id)
                  }
                }
              }
            }
          }
        }
        this.options2.data = iCanList
        this.options2.includeHeadersOnDownload = dataPeriodsQualifications.options.includeHeadersOnDownload
        this.options2.operator = dataPeriodsQualifications.options.operator
        this.options2.automatic = dataPeriodsQualifications.options.automatic
        this.options2.nestedHeaders = dataPeriodsQualifications.options.nestedHeaders
        this.options2.columns = dataPeriodsQualifications.options.columns
        if (this.listBy === 'student') {
          this.options2.columns[1].title = 'Description'
        } else {
          this.options2.columns[1].title = 'Name'
        }
        // this.options2.defaultColAlign = 'left'
        if (this.firstTime < 1) {
          const gradesExcel = jexcel(this.$refs.spreadsheetStudent, this.options2)
          this.gradesExcel = Object.assign({}, gradesExcel)
        } else {
          document.getElementById('spreadsheetStudent').innerHTML = ''
          const gradesExcel = jexcel(this.$refs.spreadsheetStudent, this.options2)
          this.gradesExcel = Object.assign({}, gradesExcel)
        }
        this.firstTime = 1
      }
    },
    setDataMissingQualifications(err, dataMissing, idClass) {
      if (idClass !== null) {
        this.idClass = idClass
      }
      if (err) {
        this.error = err.toString()
      } else {
        this.qualificationData = dataMissing
      }
    },
    openModalStudents() {
      this.$bvModal.show('modal-missing-grades')
    },
    onTabChange(key, type) {
      this[type] = key
    },
    changeTab(key) {
      this.tabActive = key
      this.listBy = 'student'
    },
    searchBy() {
      let elective = this.isElective ? '?elective=true' : '?elective=false'
      if (this.childSelected !== '') {
        elective = elective + '&childSelected=' + this.childSelected
      }
      apiClient.get(`/qualifications/sbg/classes/${this.dataClass.id + elective}`).then(response => {
        this.setDataPeriodsQualifications(null, response.data)
        this.setDataQualifications(null, response.data)
      })
      apiClient.get(`/descriptors/icans/${this.dataClass.id + elective}`).then(response => {
        this.setDataICanList(null, response.data)
      })
    },
    openSearchCreateICan(descriptor) {
      this.descriptorSelectedToEdit = descriptor
      this.$bvModal.show('modal-search-create-iCan')
    },
    recieveUpdatedAt(updatedAt) {
      this.lastUpdated = updatedAt
    },
    recieveDescriptor(descriptor) {
      if ((this.descriptors.filter(di => di.id === descriptor.id)).length > 0) {
        Toast.fire({
          icon: 'warning',
          title: 'Este descriptor ya se encuentra agregado a la clase',
        })
      } else {
        const elective = this.$route.query.elective === true ? '?elective=true' : ''
        apiClient.post(`descriptors/${descriptor.id + elective}`, { idDescriptor: descriptor.id, idClass: this.dataClass.id }).then(response => {
          Toast.fire({
            icon: 'success',
            title: 'Descriptor agregado, recuerde que debe asociar el descriptor \n con los yo puedo pertinentes.',
          })
          this.searchDescriptorICan()
        }).catch(error => {
          this.$notification.error({
            message: 'Ooops ocurrió un error',
            description: showErrorMessage(error),
          })
        })
      }
    },
    recieveICan(iCan, idDescriptor = 1) {
      this.$bvModal.hide('modal-search-create-iCan')
      const elective = this.$route.query.elective === true ? '?elective=true' : ''
      apiClient.patch(`descriptors/${idDescriptor}/icans/${iCan.id + elective}`, { idClass: this.dataClass.id }).then(response => {
        this.iCanOptions.push({
          value: response.data.id,
          text: response.data.id + ' - ' + response.data.description,
        })
        this.iCanOptions = [...this.iCanOptions]
        Toast.fire({
          icon: 'success',
          title: 'Yo puedo agregado al descriptor exitosamente.',
        })
        this.searchDescriptorICan()
      }).catch(error => {
        this.$notification.warning({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    },
    removeICan(idICan, idDescriptorICan) {
      const total = this.descriptors.filter(descriptorF => descriptorF.iCanList.filter(iCanF => iCanF.id === idICan).length > 0).length
      const elective = this.$route.query.elective === true ? '?elective=true' : ''
      if (total === 1) { // Es el único yo puedo asociado en la materia
        Swal.fire({
          title: 'Mensaje de confirmación',
          text: '¿Desea remover el yo puedo con código ' + idICan + ' del descriptor? Se borrará las calificaciones asociadas a este yo puedo del presente periodo.',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, retirar.',
          cancelButtonText: 'No.',
        }).then((result) => {
          if (result.isConfirmed) {
            apiClient.delete(`/descriptor-icans/${idDescriptorICan + elective}`).then(response => {
              this.searchBy()
              this.missingQualifications(elective)
              this.$notification.success({
                message: response.data,
              })
            }).catch(e => {
              this.$notification.warning({
                message: showErrorMessage(e),
              })
            })
          }
        })
      } else {
        apiClient.delete(`/descriptor-icans/${idDescriptorICan + elective}`).then(response => {
          this.searchDescriptorICan()
          this.$notification.success({
            message: response.data,
          })
        }).catch(e => {
          this.$notification.warning({
            message: showErrorMessage(e),
          })
        })
      }
    },
    removeDescriptor(idDescriptorICan) {
      apiClient.delete(`/descriptor-icans/${idDescriptorICan}`).then(response => {
        this.searchDescriptorICan()
        this.$notification.success({
          message: response.data,
        })
      }).catch(e => {
        this.$notification.warning({
          message: showErrorMessage(e),
        })
      })
    },
    searchDescriptorICan() {
      const elective = this.$route.query.elective === true ? '?elective=true' : ''
      apiClient.get(`/descriptors/icans/${this.dataClass.id + elective}`).then(response => {
        this.iCanList = response.data.iCanList
        this.descriptors = response.data.descriptorList
      }).catch(error => {
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    },
    beforeChange(instance, cell, x, y, value) { // Validations
      if (value === '') {
        return value
      }
      if (isNaN(parseInt(value)) || !isFinite(value)) {
        return 0
      }
      if (value === '0' || value === '0.0') {
        return 0
      }
      value = parseInt(value)
      if (value > this.dataClass.range.max || value < this.dataClass.range.min) {
        return 0
      }
      return value
    },
    changed(instance, cell, x, y, value) {
      for (const item of this.options.automatic) {
        if (item.type === 'prom') {
          if ((x >= item.start && x <= item.end)) {
            let average = 0
            let count = 0
            for (let xi = item.start; xi <= item.end; xi++) {
              if (this.jExcelObj.getValueFromCoords(xi, y) !== '') {
                average += parseInt(this.jExcelObj.getValueFromCoords(xi, y))
                count++
              }
            }
            if (count !== 0) {
              average /= count
            }
            average = average === 0 ? 0.1 : average
            this.jExcelObj.setValueFromCoords(item.col, y, average.toFixed(1), true)
          }
        } else if (item.type === 'percentage') {
          if (item.elements.map(e => e.col).some(e => parseInt(e) === parseInt(x))) {
            let sum = 0
            for (const element of item.elements) {
              if (this.jExcelObj.getValueFromCoords(element.col, y) !== '') {
                sum += (parseInt(this.jExcelObj.getValueFromCoords(element.col, y)) * (element.p / 100))
              }
            }
            this.jExcelObj.setValueFromCoords(item.col, y, sum, true)
          }
        }
      }
    },
    canUpdate() {
      if (this.dataClass.assistantTeacher === this.$store.state.user.id || this.dataClass.idTenuredTeacher === this.$store.state.user.id ||
        hasPermission([consts.permissions.UPDATE_CLASSES_RESOURCES], this.user.permissions)) {
        return true
      } else {
        this.$notification.error({
          message: 'No tiene permisos suficientes',
        })
        return false
      }
    },
    afterchanges() {
      if (this.autoSave) {
        clearTimeout(this.typingTimer)
        this.typingTimer = setTimeout(() => { this.saveGrades() }, 500)
      } else {
        this.isRecentChanges = true
      }
    },
    missingQualifications (elective) {
      apiClient.get('/qualifications/sbg/classes/' + this.idClass + '/missing-qualifications' + elective).then(response => {
        this.setDataMissingQualifications(null, response.data, null)
      }).catch(error => {
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    },
    saveGrades() {
      let elective = this.isElective ? '?elective=true' : '?elective=false'
      if (this.childSelected !== '') {
        elective = elective + '&childSelected=' + this.childSelected
      }
      const typeOf = {
        type: this.listBy,
        optionSelected: this.optionSelected,
      }
      let gradesForSend = ''
      if (this.listBy === 'iCan') {
        gradesForSend = this.options.data
      } else {
        gradesForSend = this.options2.data
      }
      apiClient.patch(`/qualifications/sbg/classes/${this.dataClass.id}/grades`, { grades: gradesForSend, isElective: this.isElective, currentPeriod: this.currentPeriod, typeOf: typeOf }).then(response => {
        if (!this.autoSave) {
          this.isRecentChanges = false
          Toast.fire({
            icon: 'success',
            title: 'Cambios guardados.',
          })
        }
        this.lastUpdated = response.data.lastUpdated
        this.missingQualifications(elective)
      }).catch(error => {
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    },
    getGroupExport () {
      return new Promise((resolve, reject) => {
        const sentParams = {
          idTenuredTeacher: this.dataExport.idTenuredTeacher,
          idSubject: this.dataExport.idSubject,
          idGroup: this.dataExport.idGroup,
          idGrade: this.dataExport.idGrade,
        }
        apiClient2.get('/descriptors', { params: sentParams }).then(response => {
          this.groupName.push(response.data.data)
          this.isGroupName = this.groupName[0].length > 0
          resolve()
        }).catch(error => {
          ToastFire('error', `${showErrorMessage(error)}`)
          reject(error)
        })
      })
    },
    exportDescriptorsIcans() {
      const sentParams = {
        descriptorIcan: this.descriptors,
        idGroupSubjectYear: this.selected,
      }
      this.$bvModal.hide('modal-export-descriptorIcan')
      apiClient2.post(`/descriptors/source-group/${this.dataExport.idSubject}`, { sentParams }).then(response => {
        Toast.fire({
          icon: 'success',
          title: 'Exportación exitosa',
        })
      }).catch(error => {
        Toast.fire({
          icon: 'warning',
          title: showErrorMessage(error),
        })
      })
    },
    clearSelected () {
      this.selected = []
      this.$bvModal.hide('modal-export-descriptorIcan')
    },
  },
  created() {
    if (this.periodFinalDate !== null) {
      const now = moment()
      const finalDate = moment(this.periodFinalDate)
      if (finalDate.diff(now, 'days') < 21) {
        this.checkTimeLeft = 'Quedan ' + finalDate.diff(now, 'days') + ' días y ' + moment.duration(finalDate.diff(now)).hours() + ' horas para cerrar el periodo'
      } else if (finalDate.diff(now, 'seconds') < 1) {
        this.checkTimeLeft = 'Periodo finalizado'
      }
      this.periodEnd = finalDate.diff(now, 'seconds') < 1
    }
    this.timer = setInterval(() => {
      this.timeLeft()
      return this.intervalTimer
    }, this.intervalTimer)
    this.idRoles = JSON.parse(store.get('userData')).idRoles
  },
  beforeDestroy() {
    this.intervalTimer = 30000
    clearInterval(this.timer)
  },
}
</script>
<style lang="scss">
@import "./style.module.scss";
</style>
